import { Component, OnInit, ViewChild } from '@angular/core';
import { Cgu } from 'src/app/classes/Cgu/cgu';
import { ModulesManagerService } from 'src/app/classes/Module/modules-manager.service';
import { ScrollDetail, IonContent } from '@ionic/angular';
import { LoggerService } from '../../../utils/logger.service';



@Component({
  selector: 'app-terms',
  templateUrl: './terms.page.html',
  styleUrls: ['./terms.page.scss'],
  standalone: false
})
export class TermsPage implements OnInit {

  @ViewChild(IonContent) content: IonContent;

  constructor(public manager: ModulesManagerService) { }
  private tolerance = 1;
  private cgu: Cgu;
  private pending = false
  private isFullyScrolled: boolean;
  public handler: any;
  public dataAccepted = false
  public termsAccepted = false


  async ionViewWillEnter() {
    if (!this.cgu && !this.pending) {
      this.pending = true
      this.cgu = (await this.manager.GetModuleData('Cgus', 0).catch((error) => LoggerService.error('Erreur lors de la récupération des CGU', error)))[0];
      this.pending = false
    }
  }

  ngOnInit() { }

  get IsFullyScrolled() {
    return true
    // return this.isFullyScrolled
  }

  get Documents() {
    return this.cgu?.Documents;
  }

  async handleScroll(ev: CustomEvent<ScrollDetail>) {
    const scrollElement = await this.content.getScrollElement(); // get scroll element
    this.isFullyScrolled = (scrollElement.scrollTop + this.tolerance >= scrollElement.scrollHeight - scrollElement.clientHeight) || this.IsFullyScrolled;
  }

  public clickOnCheckbox(ev: Event) {
    if (!this.IsFullyScrolled && this.manager.Navi.isSelected('register')) {
      ev.preventDefault()
      ev.stopPropagation()
      this.dataAccepted = false
      this.termsAccepted = false
      return this.manager.Tool.notify(this.manager.Trad.Parse("STR_SCROLL_TO_ACCEPT"))
    }
  }

  close(exec = true) {
    if (this.handler != null && exec) this.handler(false)
    this.manager.closeModal()
  }

  public acceptCgu() {

    if (this.handler == null) return this.close()

    if (!(this.dataAccepted && this.termsAccepted)) {
      return this.manager.Tool.notify(this.manager.Trad.Parse(!this.IsFullyScrolled && this.manager.Navi.isSelected('register') ? "STR_SCROLL_TO_ACCEPT" : "STR_TERMS_NOT_ACCEPTED"))
    }

    this.close(false)
    return this.handler(this.dataAccepted && this.termsAccepted)
  }

}
